import React from 'react';
import { stats } from '../data/hero';
export function Stats() {
  return <section aria-label="Risultati reali" className="border-y border-grape/10 bg-white/70" data-id="element-149" data-mp="2wxq9bxqydsbk">
      <div className="mx-auto max-w-5xl px-5 py-8" style={{
      paddingTop: "10px",
      paddingBottom: "10px"
    }} data-id="element-150" data-mp="2ixxpmmdugcd3">
        <dl className="grid grid-cols-2 gap-6 sm:grid-cols-4" data-id="element-151" data-mp="2nx1zzgci8g50">
          {stats.map(s => <div key={s.label} className="text-center" data-id="element-152" data-mp="2nyv5utfamwby">
              <dt className="font-display text-4xl font-black text-plum sm:text-5xl" data-id="element-153" data-mp="2972z35tkeqlu">{s.value}</dt>
              <dd className="mt-1 text-sm font-medium text-plum/60" data-id="element-154" data-mp="2dzw3ttp19yxx">{s.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}